export interface DescriptiveLoaderSection {
    text: string;
    duration?: number;
}

export enum DescriptiveLoaderType {
    AIStudioGen = 'AIStudioGen',
    PSDImport = 'PSDImport'
}
